module.exports = __webpack_public_path__ + "static/photogrammetry_images-75df6c286f9a24f4f49b9734dce4a49a.png";